<script setup>
  import { defineProps, defineEmits, ref } from 'vue';
  import { Sheet as KSheet } from 'konsta/vue';
  import Dialog from '../components/DialogConfirm.vue'

  import { kSheet } from 'konsta/vue';

  import { XMarkIcon } from '@heroicons/vue/24/outline'
  


  const props = defineProps({
    showOpen: Boolean,
    hiddenNumber : Object,
    error : String
  });

  const emit = defineEmits(['checkNumber', 'close']);

  const number = ref('')
  const dialogConfirm = ref(false)
  function dialogResponse(boolean){
    if (boolean) {
      emit('checkNumber', number.value);
      dialogConfirm.value = false
    }else{
      dialogConfirm.value = false
    }
  }
</script>

<template>
  <k-sheet class="w-full" :opened="props.showOpen" @sheet:close="emit('close', false)">
    <div class="p-4 w-full flex justify-center items-center flex-col">
      <div class="flex w-full justify-between items-center">
        <h3 class="text-center w-full font-bold">Verifica il tuo numero di telefono</h3>
        <span class="ml-auto cursor-pointer" @click="emit('close', false)"><XMarkIcon class="w-5"/></span>
      </div>
      <p class="text-center w-full mt-2">Inserisci il numero di telefono che hai utilizzato per la prenotazione:</p>
      <div class="flex border items-center mt-2">
        <div class="p-2">
          {{ props.hiddenNumber?.phoneCode }}
        </div>
        <input
          type="text"
          class="placeholder-center border-none flex-grow"
          :placeholder="props.hiddenNumber?.number"
          v-model="number"
        />
      </div>

      <p class="text-red-400 mt-2">{{ props.error }}</p>
      
      <button class="mt-4 bg-primary text-white py-2 px-4 rounded hover:bg-primary-dark" @click="dialogConfirm = true">Verifica Numero</button>
    </div>
  </k-sheet>

  <Dialog 
    :dialogOpen = 'dialogConfirm'
    @response = "dialogResponse($event)"
  />
</template>
